export default __webpack_public_path__ + "8e9ded7bd70b99959b619a1d41442f2c.svg";